import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, OnInit, Signal, ViewChild } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TuiAvatarModule, TuiCarouselModule, TuiTabsModule } from '@taiga-ui/kit';
import {
    Cart,
    CartPageStore,
    selectCart,
    selectIsNewCart,
    selectLoading,
    selectShowAddItemButton
} from '@us/web/cart/data-access';
import { Store } from '@ngrx/store';
import { TuiLetModule } from '@taiga-ui/cdk';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiButtonModule, TuiLoaderModule } from '@taiga-ui/core';
import { RouterLink } from '@angular/router';
import { CartComponent } from '../../components/cart/cart.component';
import { OrderStatusComponent } from '@us/web/orders/feature';
import { Observable } from 'rxjs';
import { CartCheckoutBtnComponent } from '../../components/cart-checkout-btn/cart-checkout-btn.component';
import { isFnBApp } from '@us/web/shared/utils';
import { ENVIRONMENT } from '@us/app-config';
import { Shop } from '@us/web/shared/data-access';
import { selectShop } from '@us/web/shop/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'us-cart-at-the-table',
    standalone: true,
    imports: [
        TuiTabsModule,
        TuiLetModule,
        AsyncPipe,
        TranslocoModule,
        NgIf,
        TuiButtonModule,
        RouterLink,
        TuiCarouselModule,
        CartComponent,
        OrderStatusComponent,
        CartCheckoutBtnComponent,
        TuiLoaderModule,
        TuiAvatarModule
    ],
    templateUrl: './cart-at-the-table.component.html',
    styleUrls: ['./cart-at-the-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartAtTheTableComponent implements OnInit {
    @ViewChild('topScrollAnchor') topScroll!: ElementRef;
    private readonly store = inject(Store);
    private readonly cartStore = inject(CartPageStore);
    loading$: Observable<boolean> = this.store.select(selectLoading);

    readonly currentTabIndex$ = this.cartStore.currentTabIndex$;

    readonly cart: Signal<Cart> = this.store.selectSignal(selectCart);
    readonly isNewCart = this.store.selectSignal(selectIsNewCart);
    readonly showAddItemButton = this.store.selectSignal(selectShowAddItemButton);
    readonly cart$: Observable<Cart> = this.store.select(selectCart);
    readonly shop: Signal<Shop> = this.store.selectSignal(selectShop);
    readonly isCartOwner = this.cartStore.isCartOwner;
    private readonly env = inject(ENVIRONMENT);
    readonly isFnb = isFnBApp(this.env);
    private readonly destroyRef = inject(DestroyRef);

    handleChangeTab(index: number) {
        this.cartStore.setCurrentTabIndex(index);
    }

    ngOnInit(): void {
        this.currentTabIndex$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(index => {
                if (this.topScroll && index == 1) {
                    this.topScroll.nativeElement.scrollIntoView();
                }
            });
    }
}
